import { Fragment, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { DocumentService } from "../../../services/document/document.service";
import { getEnv } from "../../../AppConfigs";
import { mailRegexs } from "../../../constants/mailTemplateConstants";
import { MailService } from "../../../services/mail/mail.service";
import { useSelector } from "../../../store/store";
import AcceptRefuseProcessModal from "../modal/accept-refuse-process-modal";
import { FontFa } from "../../../components";
import { getDiffDay } from "../../../helper/dateTimeHelper";
import { useUser } from "../../../hook";

type ApproveProcessProps = {
  docId: string;
  isOwner: boolean;
  document: any;
  docApproveData: any[];
  userEmail: string;
  updateFields: string;
  onReject: (status?: string) => void;
  setIsShowNextStepButton: (state: boolean) => void;
};

export const ApproveProcess = (props: ApproveProcessProps) => {
  const { docId, document, docApproveData, onReject, userEmail, updateFields, setIsShowNextStepButton } = props;
  const totalDetectors = docApproveData?.length || 0;
  const [doneDetectors, setDoneDetectors] = useState(docApproveData?.filter((e: any) => e.isDone).length || 0);
  const currentUserIndex = docApproveData?.findIndex((e: any) => e.email === userEmail);
  const [isDoneCompose, setIsDoneCompose] = useState(!!docApproveData[currentUserIndex]?.isDone);
  const detailUrl = getEnv("REACT_APP_DOCUMENT_DETAILS_URL");
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const status = updateFields === "docDetectors" ? "soát xét" : "kiểm tra";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [actionClick, setActionClick] = useState("" as string);
  const { name, email } = useUser();

  const openAcceptModal = () => {
    setIsModalOpen(true);
    setActionClick("approve");
  };

  const openRefuseModal = () => {
    onReject(status);
  };

  const handleConfirm = async (textValue: string) => {
    if (actionClick === "approve") {
      docApproveData[currentUserIndex].isDone = true;
      docApproveData[currentUserIndex].date = new Date();
      docApproveData[currentUserIndex].comment = textValue || "";

      const fields = {
        [updateFields]: JSON.stringify(docApproveData),
      };

      try {
        await DocumentService.updateFileInfo(docId, fields);
        setDoneDetectors(doneDetectors + 1);
        setIsDoneCompose(!isDoneCompose);
        sendMail("accept", textValue);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const renderEditorsTitle = (): string => {
    const getIconFinish = (isDone: boolean) => (isDone ? " ✔" : " 💬");
    const titleTextArr = docApproveData.map((e: any) => e.displayName + getIconFinish(e.isDone));
    titleTextArr.reverse();
    return titleTextArr.join("\n");
  };

  const sendMail = (action: string, comment: string) => {
    let url = `${detailUrl}/${document?.listItemId}?fileId=${document?.fileId}&action=process&index=2`;
    const template = mailtemplates.find((m: any) =>
      action === "refuse" ? m.eMailType === "PRDC" : m.eMailType === "PADC",
    );
    const subject = template.eSubject.replace("{0}", document?.Title || "").replace("{1}", status);
    const content = template.eContent
      .replace(mailRegexs.zero + ";", document?.Title || "")
      .replace(mailRegexs.one + ";", document?.docCode || "")
      .replace(mailRegexs.two + ";", comment)
      .replace(mailRegexs.three + ";", status)
      .replace(mailRegexs.four + ";", name)
      .replace(mailRegexs.five + ";", email)
      .replace(mailRegexs.siteUrl, url);
    MailService.sendMailByBotit({ content, subject, toMail: document.userEmail });

    // const message = MailService.buildMailMesssage(subject, content, "html", document.userEmail);
    // MailService.sendMail(message);
  };

  useEffect(() => {
    if (doneDetectors === totalDetectors) {
      setIsShowNextStepButton(true);
    }
  }, [doneDetectors, setIsShowNextStepButton, totalDetectors]);

  return (
    <Fragment>
      <div className="text-right mt-3">
        {docApproveData && docApproveData.length > 0 && (
          <span className="mr-2 pt-4" title={renderEditorsTitle()}>
            Số người thực hiện: {doneDetectors}/{totalDetectors}
          </span>
        )}
        {docApproveData && docApproveData.length > 0 && currentUserIndex > -1 && (
          <div>
            {!isDoneCompose ? (
              <>
                <Button className="mr-2" size={"sm"} onClick={openAcceptModal} variant="outline-info">
                  {"Đạt"}
                </Button>
                <Button className="mr-2" size={"sm"} onClick={openRefuseModal} variant="outline-danger">
                  {"Không đạt"}
                </Button>
                {getDiffDay(new Date().toISOString(), document.effectiveTo) < 0 && (
                  <Button title="Trễ hạn phê duyệt" variant="outlined" disabled>
                    <FontFa name="faExclamationCircle" size={"lg"} color="#cc3300" />
                  </Button>
                )}
              </>
            ) : (
              <Button style={{ boxShadow: "none" }} disabled={isDoneCompose} variant={"outline-success"} size="sm">
                Anh chị đã hoàn tất {status.toLowerCase()}
              </Button>
            )}
          </div>
        )}
      </div>
      <AcceptRefuseProcessModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        action={actionClick}
        status={status}
        handleConfirm={handleConfirm}
      />
    </Fragment>
  );
};
